import React from 'react';
import * as PropTypes from 'prop-types';
import ImageBox from '../../../../ImageBox';
import SellLabel from '../../../Labels/SellLabel';
import DiscountLabel from '../../../Labels/DiscountLabel';
import { getRecNumString } from '../../../utils';
import { imgUrlTransform } from '../../../../../util-lib/image';

const S4x3 = ({ data, discountLabelsAlign }) => {
  const {
    imageUrl, videoImageUrl, name, lightSpot, recNum
  } = data;
  const {
    finalPrice, marketPrice, sellTags, preferenceTags
  } = data;
  const image = imgUrlTransform(videoImageUrl || imageUrl, { both: '480x360' });
  return (
    <div data-layout="1-1" data-scale="4x3">
      <div className="gu-top">
        <div className="gu-image">
          <ImageBox loadAtOnce image={image} />
        </div>
        <div className="gu-info">
          {
            !!lightSpot && (
              <h3>{lightSpot}</h3>
            )
          }
          <h2>{name}</h2>
          <SellLabel data={sellTags} />
        </div>
      </div>
      <div className="gu-bottom">
        <div className="sold-text">
          {getRecNumString(recNum)}
          人预订过
        </div>
        <div className="price-and-discount">
          <DiscountLabel data={preferenceTags} align={discountLabelsAlign} />
          <div className="price">
            <span className="line_price">¥{marketPrice}</span>
            <span className="currency">¥</span>
            <strong>{finalPrice}</strong>
            <span className="qi">起</span>
          </div>
        </div>
      </div>
    </div>
  );
};

S4x3.propTypes = {
  data: PropTypes.shape({}),
  discountLabelsAlign: PropTypes.string
};

export default S4x3;
